import { css, cx } from '@linaria/atomic';

export type BodyProps = React.PropsWithChildren<object> & React.HTMLAttributes<HTMLDivElement>;

const body = css`
  grid-area: content;
`;

export function Body({ children, ...rest }: BodyProps) {
  return (
    <div {...rest} className={cx(body, rest.className)}>
      {children}
    </div>
  );
}
